export const USD_CURRENCY = { id: 1, value: 'USD' } as const;
